export default function serializableObj(obj: Record<string, any> | any[]): any {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => serializableObj(item));
  }

  const result_obj: Record<string, any> = {};
  for (const [key, val] of Object.entries(obj)) {
    if (typeof val !== 'function' && typeof val?.emit !== 'function') {
      result_obj[key] = serializableObj(val);
    }
  }
  return result_obj;
}